module.exports = __webpack_public_path__ + "tk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tk.svg
// module id = 842
// module chunks = 0